import { MapTo } from '@adobe/aem-react-editable-components';
import spreadModelProps from 'helpers/spreadModelProps';
import HelloWorld from './HelloWorld';

const HelloWorldEditableConfig = {
  emptyLabel: 'Hello World Component',
  isEmpty: (props) => !props || (!props.heading && !props.description),
};
export default MapTo('aweb/components/content/helloworldReact')(spreadModelProps(HelloWorld), HelloWorldEditableConfig);
